(function () {
  var root = document.querySelector('[data-strikeman-product-page]');
  if (!root) return;

  function alignGalleryControls() {
    var gallery = root.querySelector('.spp-gallery-card');
    var media = root.querySelector('.spp-main-media');
    if (!gallery || !media) return;
    function updateControlCenter() {
      var item = media.querySelector('.spp-main-image, .spp-main-video');
      if (!item) return;
      var bounds = item.getBoundingClientRect();
      var sourceWidth = item.naturalWidth || item.videoWidth || bounds.width;
      var sourceHeight = item.naturalHeight || item.videoHeight || bounds.height;
      if (!sourceWidth || !sourceHeight) return;
      var paintedHeight = Math.min(bounds.height, bounds.width * sourceHeight / sourceWidth);
      var center = bounds.top - gallery.getBoundingClientRect().top + paintedHeight / 2;
      gallery.style.setProperty('--spp-gallery-control-center', center + 'px');
    }
    media.addEventListener('load', updateControlCenter, true);
    media.addEventListener('loadedmetadata', updateControlCenter, true);
    if (window.ResizeObserver) {
      var sizeObserver = new ResizeObserver(updateControlCenter);
      sizeObserver.observe(gallery);
      sizeObserver.observe(media);
    } else {
      window.addEventListener('resize', updateControlCenter);
    }
    var mediaObserver = new MutationObserver(updateControlCenter);
    mediaObserver.observe(media, { childList: true });
    updateControlCenter();
  }

  alignGalleryControls();


  function centsToMoney(cents) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    return '$' + (amount / 100).toFixed(2);
  }

  function injectGalleryArrowStyle() {
    if (document.getElementById('strikeman-product-gallery-arrow-style')) return;
    var style = document.createElement('style');
    style.id = 'strikeman-product-gallery-arrow-style';
    style.textContent = [
      '.spp-gallery-card .spp-main-media{margin-right:52px;}',
      '.spp-gallery-card .spp-gallery-arrow{z-index:4;}',
      '.spp-gallery-card .spp-gallery-arrow--prev{left:88px;}',
      '.spp-gallery-card .spp-gallery-arrow--next{right:18px;}',
      '@media screen and (max-width:749px){.spp-gallery-card .spp-main-media{margin-right:-15px;}.spp-gallery-card .spp-gallery-arrow{display:none;}}'
    ].join('');
    document.head.appendChild(style);
  }

  injectGalleryArrowStyle();

  function productResourceIcon(name) {
    var icons = {
      menuBook: '<svg class="strikeman-product-resources__icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M18.6667 12.8667V11.2667C19.4 10.9556 20.15 10.7222 20.9167 10.5667C21.6833 10.4111 22.4889 10.3333 23.3333 10.3333C23.9111 10.3333 24.4778 10.3778 25.0333 10.4667C25.5889 10.5556 26.1333 10.6667 26.6667 10.8V12.2667C26.1333 12.0667 25.5944 11.9167 25.05 11.8167C24.5056 11.7167 23.9333 11.6667 23.3333 11.6667C22.4889 11.6667 21.6778 11.7722 20.9 11.9833C20.1222 12.1944 19.3778 12.4889 18.6667 12.8667ZM18.6667 20.2V18.5667C19.4 18.2667 20.15 18.0417 20.9167 17.8917C21.6833 17.7417 22.4889 17.6667 23.3333 17.6667C23.9111 17.6667 24.4778 17.7111 25.0333 17.8C25.5889 17.8889 26.1333 18 26.6667 18.1333V19.6C26.1333 19.4 25.5944 19.25 25.05 19.15C24.5056 19.05 23.9333 19 23.3333 19C22.4889 19 21.6778 19.1 20.9 19.3C20.1222 19.5 19.3778 19.8 18.6667 20.2ZM18.6667 16.5333V14.9333C19.4 14.6222 20.15 14.3889 20.9167 14.2333C21.6833 14.0778 22.4889 14 23.3333 14C23.9111 14 24.4778 14.0444 25.0333 14.1333C25.5889 14.2222 26.1333 14.3333 26.6667 14.4667V15.9333C26.1333 15.7333 25.5944 15.5833 25.05 15.4833C24.5056 15.3833 23.9333 15.3333 23.3333 15.3333C22.4889 15.3333 21.6778 15.4389 20.9 15.65C20.1222 15.8611 19.3778 16.1556 18.6667 16.5333ZM8.26667 22C9.45711 22 10.6158 22.1389 11.7427 22.4167C12.8698 22.6944 13.9778 23.1111 15.0667 23.6667V9.43333C14.0667 8.76667 12.982 8.25 11.8127 7.88333C10.6433 7.51667 9.46133 7.33333 8.26667 7.33333C7.42222 7.33333 6.59444 7.43889 5.78333 7.65C4.97222 7.86111 4.15556 8.12222 3.33333 8.43333V22.9C4.02222 22.5889 4.80556 22.3611 5.68333 22.2167C6.56111 22.0722 7.42222 22 8.26667 22ZM17.0667 23.6667C18.1778 23.1111 19.2667 22.6944 20.3333 22.4167C21.4 22.1389 22.5333 22 23.7333 22C24.5778 22 25.45 22.0667 26.35 22.2C27.25 22.3333 28.0222 22.5111 28.6667 22.7333V8.43333C27.9111 8.05556 27.1131 7.77778 26.2727 7.6C25.4322 7.42222 24.5858 7.33333 23.7333 7.33333C22.5333 7.33333 21.3722 7.51667 20.25 7.88333C19.1278 8.25 18.0667 8.76667 17.0667 9.43333V23.6667ZM16.0667 26.6667C14.9333 25.8222 13.7 25.1722 12.3667 24.7167C11.0333 24.2611 9.66667 24.0333 8.26667 24.0333C7.45467 24.0333 6.65722 24.1333 5.87433 24.3333C5.09144 24.5333 4.31111 24.7778 3.53333 25.0667C3.02 25.3111 2.525 25.2778 2.04833 24.9667C1.57167 24.6556 1.33333 24.2111 1.33333 23.6333V8.2C1.33333 7.86667 1.41111 7.56111 1.56667 7.28333C1.72222 7.00556 1.95556 6.78889 2.26667 6.63333C3.2 6.18889 4.171 5.86111 5.17967 5.65C6.18856 5.43889 7.21756 5.33333 8.26667 5.33333C9.66667 5.33333 11.0278 5.52222 12.35 5.9C13.6722 6.27778 14.9111 6.85556 16.0667 7.63333C17.2 6.85556 18.4167 6.27778 19.7167 5.9C21.0167 5.52222 22.3556 5.33333 23.7333 5.33333C24.7749 5.33333 25.7963 5.43889 26.7977 5.65C27.7992 5.86111 28.7667 6.18889 29.7 6.63333C30.0111 6.78889 30.25 7.00556 30.4167 7.28333C30.5833 7.56111 30.6667 7.86667 30.6667 8.2V23.6333C30.6667 24.2531 30.4167 24.7248 29.9167 25.0483C29.4167 25.3717 28.9222 25.3778 28.4333 25.0667C27.6778 24.7556 26.9086 24.5056 26.1257 24.3167C25.3428 24.1278 24.5453 24.0333 23.7333 24.0333C22.3333 24.0333 20.9889 24.2667 19.7 24.7333C18.4111 25.2 17.2 25.8444 16.0667 26.6667Z" fill="#C02126"/></svg>',
      videocam: '<svg class="strikeman-product-resources__icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M4.66667 26.6667C4.13333 26.6667 3.66667 26.4667 3.26667 26.0667C2.86667 25.6667 2.66667 25.2 2.66667 24.6667V7.33333C2.66667 6.8 2.86667 6.33333 3.26667 5.93333C3.66667 5.53333 4.13333 5.33333 4.66667 5.33333H22C22.5333 5.33333 23 5.53333 23.4 5.93333C23.8 6.33333 24 6.8 24 7.33333V14.5L29.3333 9.16667V22.8333L24 17.5V24.6667C24 25.2 23.8 25.6667 23.4 26.0667C23 26.4667 22.5333 26.6667 22 26.6667H4.66667ZM4.66667 24.6667H22V7.33333H4.66667V24.6667Z" fill="#C02126"/></svg>',
      rateReview: '<svg class="strikeman-product-resources__icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8 18.6667H12.089L18.7353 12C18.9347 11.8 19.0841 11.5722 19.1837 11.3167C19.2834 11.0611 19.3333 10.8111 19.3333 10.5667C19.3333 10.3222 19.2852 10.0797 19.189 9.839C19.0926 9.59811 18.9481 9.37767 18.7557 9.17767L17.5377 7.929C17.3348 7.73189 17.1111 7.58333 16.8667 7.48333C16.6222 7.38333 16.3667 7.33333 16.1 7.33333C15.8556 7.33333 15.6092 7.37967 15.361 7.47233C15.113 7.56478 14.8887 7.711 14.688 7.911L8 14.5777V18.6667ZM10 16.6667V15.4L13.389 12.0333L14.0333 12.6333L14.6333 13.2777L11.2667 16.6667H10ZM14.0333 12.6333L14.6333 13.2777L13.389 12.0333L14.0333 12.6333ZM14.6333 18.6667H24V16.4443H16.8557L14.6333 18.6667ZM2.66667 29.3333V4.889C2.66667 4.289 2.887 3.76856 3.32767 3.32767C3.76856 2.887 4.289 2.66667 4.889 2.66667H27.111C27.711 2.66667 28.2314 2.887 28.6723 3.32767C29.113 3.76856 29.3333 4.289 29.3333 4.889V21.7777C29.3333 22.3777 29.113 22.8981 28.6723 23.339C28.2314 23.7797 27.711 24 27.111 24H8L2.66667 29.3333ZM7.04433 21.7777H27.111V4.889H4.889V24.0557L7.04433 21.7777Z" fill="#C8202B"/></svg>'
    };
    return icons[name] || '';
  }

  function buildProductResourcesFallback() {
    var resources = document.createElement('div');
    resources.className = 'strikeman-product-resources';
    resources.setAttribute('aria-label', 'Product resources');
    resources.innerHTML = [
      '<h3 class="strikeman-product-resources__heading">Resources</h3>',
      '<ul class="strikeman-product-resources__list" role="list">',
      '<li class="strikeman-product-resources__item"><a class="strikeman-product-resources__link" href="/pages/user-manuals" aria-label="View Strikeman user manuals">',
      productResourceIcon('menuBook'),
      '<span>User Manuals</span></a></li>',
      '<li class="strikeman-product-resources__item"><a class="strikeman-product-resources__link" href="/pages/how-to-videos" aria-label="Watch Strikeman how to videos">',
      productResourceIcon('videocam'),
      '<span>How to Videos</span></a></li>',
      '<li class="strikeman-product-resources__item"><a class="strikeman-product-resources__link" href="/blogs/news" aria-label="Read the Strikeman blog">',
      productResourceIcon('rateReview'),
      '<span>Blog</span></a></li>',
      '</ul>'
    ].join('');
    return resources;
  }

  function injectProductResourcesFallback() {
    root.querySelectorAll('[data-spp-product-description], .spp-product-description').forEach(function (description) {
      if (description.querySelector('.strikeman-product-resources')) return;
      var body = description.querySelector('.spp-description-body');
      if (!body) return;
      var content = description.querySelector('.spp-product-description-content');
      if (!content) {
        content = document.createElement('div');
        content.className = 'spp-product-description-content';
        body.parentNode.insertBefore(content, body);
        content.appendChild(body);
      }
      content.appendChild(buildProductResourcesFallback());
    });
  }

  injectProductResourcesFallback();

  function updateProductCardTimers() {
    var second = 1000;
    var minute = second * 60;
    var hour = minute * 60;
    var nowDate = new Date();
    var cycleEnd = new Date(nowDate);
    cycleEnd.setHours(24, 0, 0, 0);
    var distance = Math.max(0, cycleEnd.getTime() - nowDate.getTime());
    var hours = Math.max(0, Math.floor(distance / hour));
    var minutes = Math.max(0, Math.floor((distance % hour) / minute));
    var seconds = Math.max(0, Math.floor((distance % minute) / second));

    root.querySelectorAll('[data-spp-card-timer]').forEach(function (timer) {
      var hoursNode = timer.querySelector('[data-spp-card-timer-hours]');
      var minutesNode = timer.querySelector('[data-spp-card-timer-minutes]');
      var secondsNode = timer.querySelector('[data-spp-card-timer-seconds]');

      if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
      if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
      if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');
      timer.setAttribute('aria-label', 'Offer ends in ' + hours + ' hours, ' + minutes + ' minutes, and ' + seconds + ' seconds');
    });
  }

  if (root.querySelector('[data-spp-card-timer]')) {
    updateProductCardTimers();
    window.setInterval(updateProductCardTimers, 1000);
  }

  var defaultRecommendation = 'Select a caliber to see firearm-specific fit guidance before you add this kit to cart.';
  var pistolRestriction = 'Restrictions: Ruger SR, Walther PPK/PPK/S/CCP, Beretta AX100, and Beretta 92X Centurion need SmartShot or support review.';
  var rifleRestriction = 'Restrictions: Marlin 336, Winchester Model 54, and Savage 110 are not compatible with standard lasers.';
  var recommendationCopy = {
    '9mm': 'Works with most 9mm pistols. ' + pistolRestriction,
    '380': 'Works with most .380 ACP pistols. ' + pistolRestriction,
    '380acp': 'Works with most .380 ACP pistols. ' + pistolRestriction,
    '380 acp': 'Works with most .380 ACP pistols. ' + pistolRestriction,
    '.380 acp': 'Works with most .380 ACP pistols. ' + pistolRestriction,
    '10mm': 'Works with most 10mm pistols. ' + pistolRestriction,
    '40sw': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '.40 sw': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '.40 sandw': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '.40 s&w': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '40sandw': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '45acp': 'Works with most .45 ACP pistols. ' + pistolRestriction,
    '.45 acp': 'Works with most .45 ACP pistols. ' + pistolRestriction,
    '45 colt': 'Works with most .45 Colt firearms. Confirm whether your setup is a pistol or revolver before ordering. ' + pistolRestriction,
    '.45 colt': 'Works with most .45 Colt firearms. Confirm whether your setup is a pistol or revolver before ordering. ' + pistolRestriction,
    '357sig': 'Works with most .357 SIG pistols. ' + pistolRestriction,
    '.357 sig': 'Works with most .357 SIG pistols. ' + pistolRestriction,
    '223556': 'Works with most .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '223': 'Works with supported .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '223/556': 'Works with most .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '223/5.56': 'Works with most .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '.223/5.56': 'Works with most .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '303': 'Works with most .303 British rifles. ' + rifleRestriction,
    '303 british': 'Works with most .303 British rifles. ' + rifleRestriction,
    '308': 'Works with most .308 / 7.62x51mm rifles. ' + rifleRestriction,
    '243/308 win': 'Works with most .243 / .308 WIN rifles. ' + rifleRestriction,
    '30-30': 'Works with most 30-30 rifles. ' + rifleRestriction,
    '243': 'Works with most .243 rifles. ' + rifleRestriction,
    '.243': 'Works with most .243 rifles. ' + rifleRestriction,
    '30-06': 'Works with most 30-06 rifles. ' + rifleRestriction,
    '.30-06': 'Works with most 30-06 rifles. ' + rifleRestriction,
    '3006': 'Works with most 30-06 rifles. ' + rifleRestriction,
    '7.62x51mm': 'Works with most 7.62x51mm rifles. ' + rifleRestriction,
    '7.62 x51mm': 'Works with most 7.62x51mm rifles. ' + rifleRestriction,
    '6.5 crdmr': 'Works with most 6.5 Creedmoor rifles. ' + rifleRestriction,
    '6.5 mmc': 'Works with most 6.5 Creedmoor rifles. ' + rifleRestriction,
    '300 aac': 'Works with most .300 AAC rifles. ' + rifleRestriction,
    '.300 aac': 'Works with most .300 AAC rifles. ' + rifleRestriction,
    '300aac': 'Works with most .300 AAC rifles. ' + rifleRestriction,
    '12 gauge': 'Works only with compatible 12 Gauge shotguns. Confirm your shotgun is chambered for 12 Gauge; if not, do not select this cartridge.',
    '38 special': 'For .38 Special / .357 Magnum revolvers, use the dedicated revolver cartridge 5-pack with the Target & Phone Mount instead of the Standard Kit path.',
    '.38 special': 'For .38 Special / .357 Magnum revolvers, use the dedicated revolver cartridge 5-pack with the Target & Phone Mount instead of the Standard Kit path.'
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9./ -]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compact(value) {
    return normalize(value).replace(/[^a-z0-9]/g, '');
  }

  function recommendationFor(label) {
    var normalized = normalize(label);
    var compressed = compact(label);
    return recommendationCopy[normalized] || recommendationCopy[compressed] || 'Works with most ' + label + ' firearms. Some firearm models may require a different laser. Confirm fit before purchase.';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function formatRecommendation(copy) {
    var text = String(copy || '').trim();
    var isPistol = text.indexOf(pistolRestriction) !== -1;
    var isRifle = text.indexOf(rifleRestriction) !== -1;
    if (!isPistol && !isRifle) return escapeHtml(text);
    var intro = text.split(isPistol ? pistolRestriction : rifleRestriction)[0].trim();
    var compatible = [];
    var restrictions = [];
    if (isPistol) {
      if (/^Works with most (9mm|\.380 ACP)/.test(intro)) {
        compatible.push(['S&W M&P Shield 9mm', 'Compatible with both 9mm and .380 ACP standard laser cartridges.']);
        restrictions.push(['Girsan 9mm', 'Use a .380 ACP laser cartridge.']);
        restrictions.push(['Tanfoglio 9mm', 'Use a .380 ACP laser cartridge.']);
      }
      restrictions.push(['Ruger SR series', 'Not compatible with standard cartridges. Use SmartShot in the appropriate caliber.']);
      restrictions.push(['Walther PPK / PPK/S', 'Not compatible with standard cartridges. Use SmartShot in the appropriate caliber.']);
      restrictions.push(['Walther CCP', 'Not compatible with standard cartridges. SmartShot compatibility is unconfirmed.*']);
      restrictions.push(['Beretta AX100', 'Standard-cartridge exception.*']);
      restrictions.push(['Beretta 92X Centurion', 'Standard-cartridge exception.*']);
    } else {
      ['Marlin 336', 'Winchester Model 54', 'Savage 110'].forEach(function (model) {
        restrictions.push([model, 'Not compatible with standard laser cartridges.*']);
      });
    }
    function renderList(items) {
      if (!items.length) return '';
      return '<ul class="spp-compatibility-list">' + items.map(function (item) {
        return '<li><strong>' + escapeHtml(item[0]) + ':</strong> ' + escapeHtml(item[1]) + '</li>';
      }).join('') + '</ul>';
    }
    var title = root.querySelector('[data-spp-recommendation-title]');
    var recommendationsLabel = title ? title.textContent.trim() : 'Recommendations';
    var recommendationsDisclosure = compatible.length
      ? '<details class="spp-fit-disclosure" data-spp-fit-disclosure><summary>' +
        escapeHtml(recommendationsLabel) + '<span class="spp-fit-count">' + compatible.length +
        '</span></summary><div class="spp-fit-content">' + renderList(compatible) + '</div></details>'
      : '';
    return '<p class="spp-fit-intro">' + escapeHtml(intro) + '</p>' + recommendationsDisclosure +
      '<details class="spp-fit-disclosure spp-fit-disclosure--restrictions" data-spp-fit-disclosure>' +
      '<summary>Restrictions<span class="spp-fit-count">' + restrictions.length + '</span></summary>' +
      '<div class="spp-fit-content">' + renderList(restrictions) +
      '<p class="spp-compatibility-footnote">* Contact support before ordering.</p></div></details>';
  }

  function addClass(node, className) {
    if (!node) return;
    var classes = String(node.getAttribute('class') || '').split(/\s+/).filter(Boolean);
    if (!classes.includes(className)) classes.push(className);
    node.setAttribute('class', classes.join(' '));
  }

  function removeClass(node, className) {
    if (!node) return;
    node.setAttribute('class', String(node.getAttribute('class') || '')
      .split(/\s+/)
      .filter(function (item) { return item && item !== className; })
      .join(' '));
  }

  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-spp-thumb]'));
  var currentMediaIndex = 0;
  var mobileGalleryQuery = window.matchMedia('(max-width: 749px)');

  function closeImageModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('spp-image-modal-open');
    var image = modal.querySelector('[data-spp-image-modal-img]');
    if (image) image.removeAttribute('src');
  }

  function getImageModal() {
    var modal = document.querySelector('[data-spp-image-modal]');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'spp-image-modal';
    modal.setAttribute('data-spp-image-modal', '');
    modal.hidden = true;
    modal.innerHTML = [
      '<button class="spp-image-modal__backdrop" type="button" data-spp-image-modal-close aria-label="Close image preview"></button>',
      '<div class="spp-image-modal__dialog" role="dialog" aria-modal="true" aria-label="Product image preview">',
      '<button class="spp-image-modal__close" type="button" data-spp-image-modal-close>Close</button>',
      '<img class="spp-image-modal__image" data-spp-image-modal-img alt="">',
      '</div>'
    ].join('');
    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-spp-image-modal-close]')) closeImageModal(modal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeImageModal(modal);
    });

    return modal;
  }

  function openImageModal(src, alt) {
    if (!src) return;
    var modal = getImageModal();
    var image = modal.querySelector('[data-spp-image-modal-img]');
    if (!image) return;
    image.src = src;
    image.alt = alt || 'Product image';
    modal.hidden = false;
    modal.classList.add('is-open');
    document.documentElement.classList.add('spp-image-modal-open');
    var close = modal.querySelector('.spp-image-modal__close');
    if (close) close.focus({ preventScroll: true });
  }

  function setActiveMedia(index) {
    if (!thumbs.length) return;
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    currentMediaIndex = index;
    var firstImageBadge = root.querySelector('[data-spp-first-image-badge]');
    if (firstImageBadge) firstImageBadge.hidden = index !== 0;

    var thumb = thumbs[index];
    var mainMedia = root.querySelector('.spp-main-media');
    if (!thumb || !mainMedia) return;

    var alt = thumb.dataset.alt || '';
    if (thumb.dataset.mediaType === 'video' && thumb.dataset.videoSrc) {
      mainMedia.innerHTML = [
        '<video class="spp-main-video" controls playsinline preload="metadata" poster="' + (thumb.dataset.src || '') + '">',
        '<source src="' + thumb.dataset.videoSrc + '" type="video/mp4">',
        '</video>'
      ].join('');
    } else if (thumb.dataset.src) {
      mainMedia.innerHTML = '<img class="spp-main-image" src="' + thumb.dataset.src + '" alt="' + alt.replace(/"/g, '&quot;') + '" data-spp-main-image>';
    }
    if (firstImageBadge) mainMedia.appendChild(firstImageBadge);

    thumbs.forEach(function (item, itemIndex) {
      item.classList.toggle('is-active', itemIndex === index);
    });

    root.querySelectorAll('.spp-gallery-dots span').forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
      dot.hidden = dotIndex >= thumbs.length;
    });

    var count = root.querySelector('.spp-gallery-count');
    if (count) count.textContent = (index + 1) + ' / ' + thumbs.length;
  }

  function setButtonsEnabled(enabled, available) {
    root.querySelectorAll('[data-spp-add]').forEach(function (button) {
      if (!enabled) {
        button.disabled = false;
        button.type = 'button';
        button.setAttribute('data-spp-needs-caliber', 'true');
        button.removeAttribute('aria-disabled');
        button.textContent = button.dataset.sppDisabledLabel || button.dataset.sppReadyLabel || 'Add to cart';
      } else if (!available) {
        button.disabled = true;
        button.type = 'submit';
        button.removeAttribute('data-spp-needs-caliber');
        button.setAttribute('aria-disabled', 'true');
        button.textContent = 'Sold out';
      } else {
        button.disabled = false;
        button.type = 'submit';
        button.removeAttribute('data-spp-needs-caliber');
        button.removeAttribute('aria-disabled');
        button.textContent = button.dataset.sppReadyLabel || 'Add to cart';
      }
    });
  }

  var caliberAttentionTimer;
  var pendingAddForm = null;

  function submitPendingAddAfterCaliber(select) {
    if (!pendingAddForm || !select || !select.value) return;

    var option = select.options[select.selectedIndex];
    if (option && option.dataset.available === 'false') {
      pendingAddForm = null;
      return;
    }

    var form = pendingAddForm;
    pendingAddForm = null;

    window.setTimeout(function () {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }

      var submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      if (form.dispatchEvent(submitEvent)) form.submit();
    }, 80);
  }
  function applyCaliberAttention(select) {
    var shell = select.closest('[data-spp-caliber-shell]');
    addClass(shell, 'is-attention');
    addClass(select, 'is-attention');
    select.style.borderColor = 'transparent';
    select.style.borderWidth = '1px';
    select.style.outline = 'none';
    select.style.boxShadow = 'none';
  }

  function clearCaliberAttention(select) {
    var shell = select.closest('[data-spp-caliber-shell]');
    removeClass(shell, 'is-attention');
    removeClass(select, 'is-attention');
    select.style.borderColor = '';
    select.style.borderWidth = '';
    select.style.outline = '';
    select.style.boxShadow = '';
  }

  function getOptionSelects() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-spp-option-select]'));
  }

  function getVariantData() {
    var source = root.querySelector('[data-spp-variants]');
    if (!source) return [];
    try {
      return JSON.parse(source.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  var variantData = getVariantData();

  function selectedOptions() {
    return getOptionSelects().map(function (select) {
      return select.value || '';
    });
  }

  function firstEmptySelect() {
    return getOptionSelects().find(function (select) {
      return !select.value;
    });
  }

  function selectionIsComplete() {
    var selects = getOptionSelects();
    return !selects.length || selects.every(function (select) {
      return !!select.value;
    });
  }

  function findSelectedVariant() {
    var selects = getOptionSelects();
    if (!selects.length) {
      return variantData.find(function (variant) { return variant.available; }) || variantData[0] || null;
    }

    if (!selectionIsComplete()) return null;
    var directVariantSelect = selects.find(function (select) {
      return select.hasAttribute('data-spp-direct-variant-select');
    });
    if (directVariantSelect) {
      return variantData.find(function (variant) {
        return variant && String(variant.id) === String(directVariantSelect.value);
      }) || null;
    }

    var values = selectedOptions();
    return variantData.find(function (variant) {
      if (!variant) return false;
      return values.every(function (value, index) {
        return String((variant.options || [])[index] || '') === String(value || '');
      });
    }) || null;
  }

  function renderSelectLabel(target, text, isUnavailable) {
    if (!target) return;

    var cleanText = String(text || '').replace(/\s*\(out of stock\)\s*$/i, '').trim();
    target.textContent = cleanText;

    if (isUnavailable) {
      target.appendChild(document.createTextNode(' '));
      var status = document.createElement('span');
      status.className = 'spp-stock-status';
      status.textContent = '(OUT OF STOCK)';
      target.appendChild(status);
    }
  }

  function ensureCustomSelect(select) {
    if (!select) return null;
    var shell = select.closest('[data-spp-caliber-shell]');
    if (!shell) return null;

    if (!shell.querySelector('[data-spp-select-toggle]')) {
      var toggle = document.createElement('button');
      var label = document.createElement('span');
      var icon = document.createElement('span');
      var menuId = (select.id || 'spp-option') + '-menu';

      toggle.className = 'spp-select-toggle';
      toggle.type = 'button';
      toggle.setAttribute('data-spp-select-toggle', '');
      toggle.setAttribute('aria-haspopup', 'listbox');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', menuId);

      label.setAttribute('data-spp-select-label', '');
      renderSelectLabel(label, select.options[0] ? select.options[0].textContent.trim() : 'Select', false);
      icon.className = 'spp-select-toggle__icon';
      icon.setAttribute('aria-hidden', 'true');

      toggle.appendChild(label);
      toggle.appendChild(icon);
      select.insertAdjacentElement('afterend', toggle);
    }

    if (!shell.querySelector('[data-spp-select-menu]')) {
      var menu = document.createElement('div');
      menu.className = 'spp-select-menu';
      menu.id = shell.querySelector('[data-spp-select-toggle]').getAttribute('aria-controls');
      menu.setAttribute('data-spp-select-menu', '');
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;

      Array.prototype.slice.call(select.options).forEach(function (nativeOption) {
        if (!nativeOption.value) return;
        var isUnavailable = nativeOption.dataset.available === 'false';
        var option = document.createElement('button');
        option.className = isUnavailable ? 'spp-select-option spp-select-option--unavailable' : 'spp-select-option';
        option.type = 'button';
        option.setAttribute('role', 'option');
        option.setAttribute('data-spp-select-option', '');
        option.setAttribute('data-value', nativeOption.value);
        option.setAttribute('data-label', nativeOption.textContent.trim());
        option.setAttribute('data-available', isUnavailable ? 'false' : 'true');
        option.setAttribute('aria-selected', 'false');
        renderSelectLabel(option, nativeOption.textContent.trim(), isUnavailable);
        menu.appendChild(option);
      });

      shell.appendChild(menu);
    }

    return shell;
  }

  function syncCustomSelect(select) {
    var shell = ensureCustomSelect(select);
    if (!select || !shell) return;

    var label = shell.querySelector('[data-spp-select-label]');
    var selectedOption = select.options[select.selectedIndex];
    var selectedText = selectedOption && select.value ? selectedOption.textContent.trim() : (select.options[0] ? select.options[0].textContent.trim() : 'Select');

    var selectedIsUnavailable = !!selectedOption && selectedOption.dataset.available === 'false';
    renderSelectLabel(label, selectedText, selectedIsUnavailable);
    shell.classList.toggle('is-unavailable', selectedIsUnavailable);
    shell.querySelectorAll('[data-spp-select-option]').forEach(function (option) {
      option.setAttribute('aria-selected', option.dataset.value === select.value ? 'true' : 'false');
    });
  }

  function syncAllCustomSelects() {
    getOptionSelects().forEach(syncCustomSelect);
  }

  function openCustomSelect(selectOrShell) {
    var shell = selectOrShell && selectOrShell.matches && selectOrShell.matches('[data-spp-caliber-shell]')
      ? selectOrShell
      : ensureCustomSelect(selectOrShell || firstEmptySelect() || getOptionSelects()[0]);
    if (!shell) return;

    root.querySelectorAll('[data-spp-caliber-shell]').forEach(function (item) {
      if (item !== shell) closeCustomSelect(item);
    });

    var toggle = shell.querySelector('[data-spp-select-toggle]');
    var menu = shell.querySelector('[data-spp-select-menu]');
    if (!toggle || !menu) return;

    addClass(shell, 'is-open');
    menu.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.focus({ preventScroll: true });
  }

  function closeCustomSelect(shell) {
    var shells = shell ? [shell] : Array.prototype.slice.call(root.querySelectorAll('[data-spp-caliber-shell]'));
    shells.forEach(function (item) {
      var toggle = item.querySelector('[data-spp-select-toggle]');
      var menu = item.querySelector('[data-spp-select-menu]');
      removeClass(item, 'is-open');
      if (menu) menu.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function chooseCustomSelectOption(option) {
    var shell = option && option.closest('[data-spp-caliber-shell]');
    var select = shell ? shell.querySelector('[data-spp-option-select]') : null;
    if (!select || !option) return;

    select.value = option.dataset.value || '';
    select.dispatchEvent(new Event('change', { bubbles: true }));
    closeCustomSelect(shell);
  }

  function guideCaliberSelection() {
    var select = firstEmptySelect() || getOptionSelects()[0];
    if (!select) return;

    clearTimeout(caliberAttentionTimer);
    applyCaliberAttention(select);
    select.scrollIntoView({ behavior: 'smooth', block: 'center' });
    openCustomSelect(select);

    caliberAttentionTimer = window.setTimeout(function () {
      if (!select.value) clearCaliberAttention(select);
    }, 3000);
  }

  window.strikemanGuideCaliberSelection = function (event, button) {
    if (!button || !button.hasAttribute('data-spp-needs-caliber')) return true;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    pendingAddForm = button.closest('form') || root.querySelector('form[data-spp-product-form]');
    guideCaliberSelection();
    return false;
  };

  var selectedVariant = null;
  var successfulNotifications = {};
  function setNotifyMessage(notify, message, state) {
    var status = notify ? notify.querySelector('[data-spp-notify-status]') : null;
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', state === 'error');
    status.classList.toggle('is-success', state === 'success');
  }

  function updateNotifyState(variant) {
    var notifies = root.querySelectorAll('[data-spp-notify]');
    var shouldShow = !!variant && variant.available === false;
    var shouldShowPurchase = !!variant && variant.available === true;
    var stickyBar = root.querySelector('[data-spp-sticky-atc]');
    if (stickyBar) stickyBar.classList.toggle('is-notify-active', shouldShow);
    root.querySelectorAll('.spp-purchase-row').forEach(function (row) {
      row.hidden = !shouldShowPurchase;
      row.setAttribute('aria-hidden', shouldShowPurchase ? 'false' : 'true');
    });
    root.querySelectorAll('[data-spp-sticky-purchase]').forEach(function (purchase) {
      purchase.hidden = shouldShow;
      purchase.setAttribute('aria-hidden', shouldShow ? 'true' : 'false');
    });
    notifies.forEach(function (notify) {
      notify.hidden = !shouldShow;
      notify.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      notify.dataset.variantId = shouldShow && variant.id ? String(variant.id) : '';
      notify.dataset.variantTitle = shouldShow ? String(variant.title || '') : '';
      notify.dataset.variantSku = shouldShow ? String(variant.sku || '') : '';

      if (!shouldShow) {
        setNotifyMessage(notify, '', '');
        var input = notify.querySelector('[data-spp-notify-email]');
        if (input) input.removeAttribute('aria-invalid');
      }
    });
  }

  function updateVariantUrl(variant) {
    if (!variant || !variant.id || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      // Preserve product selection even if URL APIs are unavailable.
    }
  }

  function submitBackInStockNotification(notify) {
    if (!notify || !selectedVariant || selectedVariant.available !== false) return;
    var submittedVariantId = String(selectedVariant.id || '');
    var input = notify.querySelector('[data-spp-notify-email]');
    var button = notify.querySelector('[data-spp-notify-submit]');
    var email = input ? input.value.trim() : '';

    if (!input || !email || !input.validity.valid) {
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
      setNotifyMessage(notify, 'Enter a valid email address.', 'error');
      return;
    }

    input.removeAttribute('aria-invalid');
    var submissionKey = submittedVariantId + '|' + email.toLowerCase();
    if (successfulNotifications[submissionKey]) {
      setNotifyMessage(notify, 'You\u2019re on the list. We\u2019ll email you when this item is back in stock.', 'success');
      return;
    }

    if (typeof window.maestra !== 'function') {
      setNotifyMessage(notify, 'The notification service is unavailable. Please try again.', 'error');
      return;
    }

    var completed = false;
    var timeout = window.setTimeout(function () {
      if (completed) return;
      completed = true;
      if (button) {
        button.disabled = false;
        button.textContent = 'Notify me';
      }
      setNotifyMessage(notify, 'Something went wrong. Please try again.', 'error');
    }, 15000);

    if (button) {
      button.disabled = true;
      button.textContent = 'Submitting...';
    }
    setNotifyMessage(notify, '', '');

    function finish(state) {
      if (completed) return;
      completed = true;
      window.clearTimeout(timeout);
      if (button) {
        button.disabled = false;
        button.textContent = 'Notify me';
      }
      if (notify.dataset.variantId !== submittedVariantId) return;
      if (state === 'success') {
        successfulNotifications[submissionKey] = true;
        setNotifyMessage(notify, 'You\u2019re on the list. We\u2019ll email you when this item is back in stock.', 'success');
      } else {
        setNotifyMessage(notify, 'Something went wrong. Please try again.', 'error');
      }
    }

    window.maestra('async', {
      operation: 'BackInStock',
      data: {
        customer: {
          firstName: '',
          lastName: '',
          email: email
        },
        addProductToList: {
          product: {
            ids: {
              shopifyIDStrikeman: submittedVariantId
            }
          }
        }
      },
      onSuccess: function () { finish('success'); },
      onError: function () { finish('error'); },
      onValidationError: function () { finish('error'); }
    });
  }

  root.querySelectorAll('[data-spp-notify]').forEach(function (notify) {
    var notifyButton = notify.querySelector('[data-spp-notify-submit]');
    var notifyInput = notify.querySelector('[data-spp-notify-email]');
    if (notifyButton) notifyButton.addEventListener('click', function () { submitBackInStockNotification(notify); });
    if (notifyInput) notifyInput.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      submitBackInStockNotification(notify);
    });
  });

  var priceSnapshots = Object.create(null);
  var priceSnapshotsByOriginal = Object.create(null);
  var priceGuardObserver = null;
  var priceGuardRestoreTimer = null;

  function priceText(node) {
    return String(node && node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function currentPriceNodes() {
    return {
      container: root.querySelector('[data-spp-price]'),
      compare: root.querySelector('[data-spp-compare]'),
      sale: root.querySelector('[data-spp-sale]')
    };
  }

  function validSaleSnapshot(nodes) {
    var compareText = priceText(nodes.compare);
    var saleText = priceText(nodes.sale);
    if (!nodes.container || !nodes.compare || !nodes.sale) return null;
    if (nodes.compare.hidden || !compareText || !saleText || compareText === saleText) return null;

    return {
      compare: compareText,
      sale: saleText,
      original: nodes.container.getAttribute('data-price-original') || compareText,
      actual: nodes.container.getAttribute('data-price-actual') || saleText
    };
  }

  function rememberRenderedPrice(variantId) {
    if (!variantId) return null;
    var snapshot = validSaleSnapshot(currentPriceNodes());
    if (snapshot) {
      priceSnapshots[String(variantId)] = snapshot;
      priceSnapshotsByOriginal[snapshot.original || snapshot.compare] = snapshot;
    }
    return snapshot;
  }

  function renderPriceSnapshot(variantId, snapshot) {
    if (!variantId || !snapshot) return;
    var nodes = currentPriceNodes();
    if (!nodes.container || !nodes.compare || !nodes.sale) return;

    nodes.compare.textContent = snapshot.compare;
    nodes.compare.hidden = false;
    nodes.sale.textContent = snapshot.sale;
    nodes.container.classList.add('price-container--on-sale');
    nodes.container.classList.remove('price-container--regular');
    nodes.container.setAttribute('data-price-state', 'sale');
    nodes.container.setAttribute('data-price-original', snapshot.original || snapshot.compare);
    nodes.container.setAttribute('data-price-actual', snapshot.actual || snapshot.sale);
    priceSnapshots[String(variantId)] = snapshot;
    priceSnapshotsByOriginal[snapshot.original || snapshot.compare] = snapshot;
  }

  function guardSelectedVariantPrice() {
    var nodes = currentPriceNodes();
    if (!nodes.container) return;
    var variantId = nodes.container.getAttribute('data-regios-dopp-generic-variant-id');
    if (!variantId) return;

    if (rememberRenderedPrice(variantId)) return;
    var snapshot = priceSnapshots[String(variantId)];
    if (snapshot) renderPriceSnapshot(variantId, snapshot);
  }

  function schedulePriceGuard() {
    window.clearTimeout(priceGuardRestoreTimer);
    priceGuardRestoreTimer = window.setTimeout(guardSelectedVariantPrice, 0);
  }

  function initPriceStateGuard() {
    var nodes = currentPriceNodes();
    if (!nodes.container) return;

    rememberRenderedPrice(nodes.container.getAttribute('data-regios-dopp-generic-variant-id'));
    priceGuardObserver = new MutationObserver(schedulePriceGuard);
    priceGuardObserver.observe(nodes.container, {
      attributes: true,
      attributeFilter: ['class', 'data-price-state', 'data-price-original', 'data-price-actual'],
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function updateSelectedVariant() {
    getOptionSelects().forEach(ensureCustomSelect);
    var variant = findSelectedVariant();
    var hasSelectors = getOptionSelects().length > 0;
    var isSelected = hasSelectors ? selectionIsComplete() : !!variant;
    var hasAvailableVariants = !variantData.length || variantData.some(function (item) {
      return !!item && item.available;
    });
    var variantId = variant && variant.id ? String(variant.id) : '';
    var caliberSelect = root.querySelector('[data-spp-caliber-select]') || getOptionSelects()[0];
    var caliberOption = caliberSelect && caliberSelect.selectedIndex >= 0 ? caliberSelect.options[caliberSelect.selectedIndex] : null;
    var caliber = caliberOption && caliberOption.dataset.caliber ? caliberOption.dataset.caliber : (caliberSelect && caliberSelect.value ? caliberSelect.value : '');
    var recommendationTitle = root.querySelector('[data-spp-recommendation-title]');
    var recommendation = root.querySelector('[data-spp-recommendation]');
    var sale = root.querySelector('[data-spp-sale]');
    var compare = root.querySelector('[data-spp-compare]');
    var priceContainer = root.querySelector('[data-spp-price]');
    var previousVariantId = priceContainer && priceContainer.getAttribute('data-regios-dopp-generic-variant-id');

    rememberRenderedPrice(previousVariantId);

    root.querySelectorAll('[data-spp-variant-input]').forEach(function (input) {
      input.value = variantId;
    });

    selectedVariant = variant;
    if (recommendationTitle) recommendationTitle.hidden = hasSelectors ? !variant : false;
    if (recommendation && hasSelectors) {
      recommendation.hidden = !variant;
      if (variant) recommendation.innerHTML = formatRecommendation(recommendationFor(caliber));
      if (recommendationTitle && recommendation.querySelector('[data-spp-fit-disclosure]')) recommendationTitle.hidden = true;
    } else if (recommendation) {
      recommendation.hidden = false;
    }

    if (variant && priceContainer) {
      priceContainer.setAttribute('data-regios-dopp-generic-variant-id', variantId);
      if (variant.rawPrice) priceContainer.setAttribute('data-price-original', centsToMoney(variant.rawPrice));
    }
    if (variant && variant.compare && variant.price && variant.compare !== variant.price) {
      renderPriceSnapshot(variantId, {
        compare: variant.compare,
        sale: variant.price,
        original: variant.compare,
        actual: variant.price
      });
    } else if (variant && priceSnapshots[variantId]) {
      renderPriceSnapshot(variantId, priceSnapshots[variantId]);
    } else if (variant && variant.rawPrice && priceSnapshotsByOriginal[centsToMoney(variant.rawPrice)]) {
      renderPriceSnapshot(variantId, priceSnapshotsByOriginal[centsToMoney(variant.rawPrice)]);
    } else if (variant && previousVariantId && previousVariantId !== variantId) {
      if (sale && variant.price) sale.textContent = variant.price;
      if (compare) {
        compare.textContent = '';
        compare.hidden = true;
      }
      if (priceContainer) {
        priceContainer.classList.remove('price-container--on-sale');
        priceContainer.classList.add('price-container--regular');
        priceContainer.setAttribute('data-price-state', 'regular');
        priceContainer.setAttribute('data-price-actual', variant.price || '');
      }
    }

    if (variant && variant.rawPrice) {
      window.dispatchEvent(new CustomEvent('regios-dopp:variant-change', {
        detail: {
          selectedVariant: {
            id: Number(variant.id),
            price: Number(variant.rawPrice)
          },
          quantity: 1
        }
      }));
    }

    if (hasSelectors && !hasAvailableVariants) {
      setButtonsEnabled(true, false);
    } else {
      setButtonsEnabled(isSelected, !!variant && variant.available);
    }
    updateNotifyState(variant);
    updateVariantUrl(variant);
    syncAllCustomSelects();

    if (variant && variant.image) {
      var imageIndex = thumbs.findIndex(function (thumb) {
        return thumb.dataset.src === variant.image;
      });
      if (imageIndex >= 0) setActiveMedia(imageIndex);
    }
  }

  root.addEventListener('change', function (event) {
    if (event.target.matches('[data-spp-option-select]')) {
      if (event.target.value) clearCaliberAttention(event.target);
      updateSelectedVariant();
      if (selectionIsComplete()) submitPendingAddAfterCaliber(event.target);
    }
  });

  root.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-spp-select-toggle]');
    if (toggle && root.contains(toggle)) {
      event.preventDefault();
      var shell = toggle.closest('[data-spp-caliber-shell]');
      if (shell && shell.classList.contains('is-open')) closeCustomSelect();
      else openCustomSelect(shell);
      return;
    }

    var option = event.target.closest('[data-spp-select-option]');
    if (option && root.contains(option)) {
      event.preventDefault();
      chooseCustomSelectOption(option);
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest || target.closest('[data-spp-caliber-shell]')) return;
    closeCustomSelect();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCustomSelect();
  });

  function handleNeedsCaliberAction(event) {
    var button = event.target.closest('[data-spp-add][data-spp-needs-caliber="true"]');
    if (!button || !root.contains(button)) return;
    event.preventDefault();
    event.stopPropagation();
    pendingAddForm = button.closest('form') || root.querySelector('form[data-spp-product-form]');
    guideCaliberSelection();
  }

  root.addEventListener('pointerdown', handleNeedsCaliberAction, true);
  root.addEventListener('click', handleNeedsCaliberAction, true);

  root.addEventListener('click', function (event) {
    var mainImage = event.target.closest('.spp-main-image');
    if (mainImage && root.contains(mainImage)) {
      event.preventDefault();
      openImageModal(mainImage.currentSrc || mainImage.src, mainImage.alt);
      return;
    }

    var thumb = event.target.closest('[data-spp-thumb]');
    if (thumb) {
      var index = thumbs.indexOf(thumb);
      if (index >= 0) setActiveMedia(index);
      return;
    }

    if (event.target.closest('[data-spp-gallery-prev]')) {
      setActiveMedia(currentMediaIndex - 1);
      return;
    }

    if (event.target.closest('[data-spp-gallery-next]')) {
      setActiveMedia(currentMediaIndex + 1);
      return;
    }

    var qtyRoot = event.target.closest('[data-spp-qty]');
    if (!qtyRoot) return;
    var input = qtyRoot.querySelector('[data-spp-qty-input]');
    if (!input) return;
    var value = Math.max(1, parseInt(input.value || '1', 10));
    if (event.target.closest('[data-spp-qty-minus]')) value -= 1;
    if (event.target.closest('[data-spp-qty-plus]')) value += 1;
    input.value = Math.max(1, value);
    syncQuantities(input.value);
  });

  var gallery = root.querySelector('[data-spp-gallery]');
  if (gallery) {
    var swipeStartX = 0;
    var swipeStartY = 0;
    var swipeLastX = 0;
    var swipeLastY = 0;
    var isGallerySwipe = false;

    function shouldIgnoreGallerySwipe(target) {
      return !!target.closest('[data-spp-thumb], [data-spp-gallery-prev], [data-spp-gallery-next], button, a, input, select, textarea');
    }

    gallery.addEventListener('touchstart', function (event) {
      if (!mobileGalleryQuery.matches || event.touches.length !== 1 || shouldIgnoreGallerySwipe(event.target)) return;
      var touch = event.touches[0];
      swipeStartX = touch.clientX;
      swipeStartY = touch.clientY;
      swipeLastX = swipeStartX;
      swipeLastY = swipeStartY;
      isGallerySwipe = true;
    }, { passive: true, capture: true });

    gallery.addEventListener('touchmove', function (event) {
      if (!isGallerySwipe || !event.touches.length) return;
      var touch = event.touches[0];
      swipeLastX = touch.clientX;
      swipeLastY = touch.clientY;
    }, { passive: true, capture: true });

    gallery.addEventListener('touchend', function () {
      if (!isGallerySwipe) return;
      var deltaX = swipeLastX - swipeStartX;
      var deltaY = swipeLastY - swipeStartY;
      isGallerySwipe = false;

      if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;
      setActiveMedia(currentMediaIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true, capture: true });
  }

  function syncQuantities(value) {
    root.querySelectorAll('[data-spp-qty-input]').forEach(function (input) {
      input.value = value;
    });
  }

  root.querySelectorAll('[data-spp-qty-input]').forEach(function (input) {
    input.addEventListener('input', function () {
      syncQuantities(Math.max(1, parseInt(input.value || '1', 10)));
    });
  });

  root.querySelectorAll('form[data-spp-product-form], form[data-spp-sticky-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      var variantInput = form.querySelector('[data-spp-variant-input]');
      if (!variantInput || !variantInput.value) {
        event.preventDefault();
        guideCaliberSelection();
        return;
      }

      var formVariant = variantData.find(function (variant) {
        return variant && String(variant.id) === String(variantInput.value);
      });
      if (formVariant && formVariant.available === false) {
        event.preventDefault();
        updateNotifyState(formVariant);
        var email = root.querySelector('[data-spp-notify-email]');
        if (email) email.focus({ preventScroll: false });
        return;
      }

      event.preventDefault();
      var submit = form.querySelector('[data-spp-add]');
      var originalText = submit ? submit.textContent : '';
      var data = new FormData(form);
      var qty = Math.max(1, parseInt(data.get('quantity') || '1', 10));
      var cartSectionIds = Array.prototype.map.call(
        document.querySelectorAll('cart-items-component[data-section-id]'),
        function (component) { return component.dataset.sectionId; }
      ).filter(Boolean);
      if (cartSectionIds.length) {
        data.append('sections', cartSectionIds.join(','));
        data.append('sections_url', window.location.pathname);
      }
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding...';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function (item) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                source: 'product-form-component',
                itemCount: qty,
                variantId: item.id,
                productId: item.product_id,
                sections: item.sections
              }
            }
          }));
          if (submit) submit.textContent = 'Added';
          setTimeout(function () {
            if (submit) submit.textContent = originalText;
          }, 1600);
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submit) submit.disabled = false;
          updateSelectedVariant();
        });
    });
  });

  var faqSearch = root.querySelector('[data-spp-faq-search]');
  if (faqSearch) {
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.spp-faq-item'));
    function updateFaqResults(query) {
      var visibleCount = 0;
      faqItems.forEach(function (item) {
        var isExtra = item.hasAttribute('data-spp-faq-extra');
        var matches = !query ? !isExtra : item.textContent.toLowerCase().includes(query);
        item.hidden = !matches;
        if (matches) {
          if (query) item.open = visibleCount === 0;
          visibleCount += 1;
        }
      });
      var empty = root.querySelector('[data-spp-faq-empty]');
      if (empty) empty.hidden = visibleCount > 0;
    }

    faqSearch.addEventListener('input', function () {
      var query = faqSearch.value.toLowerCase().trim();
      updateFaqResults(query);
    });
    updateFaqResults('');
  }

  var sticky = root.querySelector('[data-spp-sticky-atc]');
  var scrollTimer;
  var lastY = window.scrollY;
  function updateStickyVisibility() {
    if (!sticky || window.matchMedia('(min-width: 750px)').matches) return;
    var movingDown = window.scrollY > lastY;
    sticky.classList.toggle('is-hidden', movingDown);
    lastY = window.scrollY;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      sticky.classList.remove('is-hidden');
    }, 220);
  }
  window.addEventListener('scroll', updateStickyVisibility, { passive: true });

  var description = root.querySelector('[data-spp-product-description]');
  var descriptionIcon = root.querySelector('[data-spp-description-icon]');
  function updateDescriptionIcon() {
    if (descriptionIcon && description) descriptionIcon.textContent = description.open ? '-' : '+';
  }
  function syncDescriptionState() {
    if (!description) return;
    updateDescriptionIcon();
  }
  syncDescriptionState();
  if (description) description.addEventListener('toggle', updateDescriptionIcon);

  var modal = root.querySelector('[data-spp-modal]');
  function closeModal() {
    if (modal) modal.hidden = true;
  }
  function openModal() {
    if (!modal) return;
    modal.hidden = false;
    var close = modal.querySelector('[data-spp-modal-close]');
    if (close) close.focus();
  }
  root.querySelectorAll('[data-spp-modal-open]').forEach(function (button) {
    button.addEventListener('click', openModal);
  });
  root.querySelectorAll('[data-spp-modal-close]').forEach(function (button) {
    button.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });

  function normalizeReviewText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getJudgeReviewRating(reviewNode) {
    var ratingNode = reviewNode.querySelector('[data-score]');
    var score = Number(ratingNode && ratingNode.getAttribute('data-score'));
    var filledStars = reviewNode.querySelectorAll('.jdgm-rev__rating .jdgm-star.jdgm--on, .jdgm-rev__rating .jdgm-star.jdgm--half').length;
    var rating = filledStars || score || 5;
    return Math.max(1, Math.min(5, Math.round(rating)));
  }

  function extractJudgeReview(reviewNode) {
    var bodyNode = reviewNode.querySelector('.jdgm-rev__body');
    var titleNode = reviewNode.querySelector('.jdgm-rev__title');
    var authorNode = reviewNode.querySelector('.jdgm-rev__author');
    var locationNode = reviewNode.querySelector('.jdgm-rev__location');
    var body = normalizeReviewText(bodyNode && bodyNode.textContent);
    var title = normalizeReviewText(titleNode && titleNode.textContent);
    var author = normalizeReviewText(authorNode && authorNode.textContent) || 'Verified buyer';
    var location = normalizeReviewText(locationNode && locationNode.textContent).replace(/[()]/g, '');
    var copy = body || title;

    if (!copy || copy.length < 8) return null;

    return {
      rating: getJudgeReviewRating(reviewNode),
      copy: copy,
      buyer: 'Verified buyer - ' + author + (location ? ' / ' + location : '')
    };
  }

  function buildProductReviewCard(review) {
    var card = document.createElement('article');
    var stars = document.createElement('div');
    var copy = document.createElement('p');
    var buyer = document.createElement('strong');

    card.className = 'spp-review-card';
    stars.textContent = '★★★★★'.slice(0, review.rating);
    stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
    copy.textContent = review.copy;
    buyer.textContent = review.buyer;

    card.appendChild(stars);
    card.appendChild(copy);
    card.appendChild(buyer);
    return card;
  }

  var track = root.querySelector('[data-spp-review-track]');
  var judgeSource = root.querySelector('[data-spp-judge-source]');
  function hydrateProductReviewCards() {
    if (!track || !judgeSource || track.getAttribute('data-product-reviews-loaded') === 'true') return;
    var seenReviews = {};
    var productReviews = Array.prototype.slice.call(judgeSource.querySelectorAll('.jdgm-rev'))
      .map(extractJudgeReview)
      .filter(function (review) {
        if (!review) return false;
        var key = review.buyer + '|' + review.copy;
        if (seenReviews[key]) return false;
        seenReviews[key] = true;
        return true;
      });

    if (productReviews.length) {
      track.innerHTML = '';
      productReviews.forEach(function (review) {
        track.appendChild(buildProductReviewCard(review));
      });
      track.setAttribute('data-product-reviews-loaded', 'true');
    }
  }
  hydrateProductReviewCards();
  if (track && judgeSource && track.getAttribute('data-product-reviews-loaded') !== 'true' && window.MutationObserver) {
    var reviewObserver = new MutationObserver(hydrateProductReviewCards);
    reviewObserver.observe(judgeSource, { childList: true, subtree: true });
  }

  if (track) {
    var reviewWrap = root.querySelector('[data-spp-review-wrap]');
    var reviewExpand = root.querySelector('[data-spp-review-expand]');
    function setProductReviewsExpanded(expanded) {
      track.classList.toggle('is-expanded', expanded);
      if (reviewWrap) reviewWrap.classList.toggle('is-expanded', expanded);
      if (reviewExpand) {
        reviewExpand.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        reviewExpand.textContent = expanded ? 'Show fewer reviews' : (reviewExpand.getAttribute('data-default-label') || 'View all');
      }
      if (expanded && typeof track.scrollIntoView === 'function') {
        track.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    if (reviewExpand) {
      reviewExpand.addEventListener('click', function (event) {
        event.preventDefault();
        setProductReviewsExpanded(!track.classList.contains('is-expanded'));
      });
    }

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    track.addEventListener('pointerdown', function (event) {
      if (track.classList.contains('is-expanded')) return;
      isDown = true;
      startX = event.pageX;
      scrollLeft = track.scrollLeft;
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', function (event) {
      if (!isDown) return;
      track.scrollLeft = scrollLeft - (event.pageX - startX);
    });
    track.addEventListener('pointerup', function () { isDown = false; });
    track.addEventListener('pointercancel', function () { isDown = false; });

    var reviewStep = function () {
      var card = track.querySelector('.spp-review-card');
      if (!card) return 320;
      var style = window.getComputedStyle(track);
      return card.getBoundingClientRect().width + parseFloat(style.columnGap || style.gap || 0);
    };
    var prevReview = root.querySelector('[data-spp-review-prev]');
    var nextReview = root.querySelector('[data-spp-review-next]');
    if (prevReview) prevReview.addEventListener('click', function () {
      track.scrollBy({ left: -reviewStep(), behavior: 'smooth' });
    });
    if (nextReview) nextReview.addEventListener('click', function () {
      track.scrollBy({ left: reviewStep(), behavior: 'smooth' });
    });
  }

  setActiveMedia(0);
  initPriceStateGuard();
  updateSelectedVariant();
})();
